import { TextField } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import InputAdornment from "@mui/material/InputAdornment";

const CustomInputComponent = ({
  field, // { name, value, onChange, onBlur }
  cancelBrowseQuestion,
  questionSeleted,
  setFieldValue,
  values,
  lang,
  form: { touched, errors }, // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.
  ...props
}) => {
  return (
    <TextField
      size="small"
      id="outlined-basic"
      name="firstName"
      variant="outlined"
      fullWidth
      error={Boolean(props.isError)}
      helperText={props.isError && props.msgError}
      placeholder={props.placeholder}
      type={props.type}
      {...field}
      InputProps={{
        style: {
          borderRadius: "5px",
        },
        inputProps: { min: 1, max: props?.threshold },
        endAdornment: questionSeleted && (
          <InputAdornment position="end">
            <CloseIcon
              sx={{ cursor: "pointer" }}
              onClick={() => {
                if (lang === "en") {
                  setFieldValue("title", "");
                  setFieldValue(
                    "choices",
                    values?.choices?.map((el) => ({
                      title: "",
                    }))
                  );
                } else {
                  setFieldValue("title_fr", "");
                  setFieldValue(
                    "choices",
                    values?.choices?.map((el) => ({
                      title_fr: "",
                    }))
                  );
                }

                cancelBrowseQuestion(false);
              }}
            />
          </InputAdornment>
        ),
      }}
    />
    //   <div>
    //   <input type="text" {...field} {...props} />
    //   {props.isError && <div className="error">{props.msgError}</div>}
    // </div>
  );
};

export default CustomInputComponent;
